// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-address-form{width:100%;padding-top:7px}.message-address-form .autocomplete{margin-bottom:20px}.message-address-form button{width:100%;margin-bottom:10px;font-size:14px;padding:0;height:40px}.message-address-form #houseNr--container{width:50%;float:left}.message-address-form #flatNr--container{width:47%;float:right}.message-address-form #postalCode--container{clear:both}.message-address-form .checkbox{padding-bottom:4px}", ""]);
// Exports
module.exports = exports;
